export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'events' as const;

export const RELATIONSHIP_TYPES = {
  USER: 'user',
  EVENT_QUOTA: 'event_quota',
  EVENT_PARTICIPANT: 'event_participant',
} as const;

export const EVENT_TYPES = {
  BREAK: 'break',
  MEETING: 'meeting',
  TRAINING: 'training',
  OTHER: 'other',
} as const;
